import * as React from "react";
const SvgOrangeWallet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      stroke="#E89B56"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.25}
      d="M4.11 18.537v-6.33A3.94 3.94 0 0 1 6.658 8.51l10.997-4.155c1.717-.651 3.559.623 3.559 2.465v5.263m-10.872 5.886h9.695m5.595 2.146a2.78 2.78 0 0 0-.831 2.258c.125 1.495 1.496 2.59 2.991 2.59h2.632v1.648a5.22 5.22 0 0 1-5.208 5.207H9.317A5.22 5.22 0 0 1 4.11 26.61v-9.32a5.22 5.22 0 0 1 5.207-5.208h15.9a5.22 5.22 0 0 1 5.207 5.207v1.994h-2.798a2.76 2.76 0 0 0-1.994.831m6.258.582v2.853c0 .762-.61 1.385-1.385 1.413h-2.714c-1.496 0-2.867-1.094-2.992-2.59-.083-.873.25-1.69.831-2.258a2.76 2.76 0 0 1 1.995-.83h2.88c.776.027 1.385.65 1.385 1.412"
    />
  </svg>
);
export default SvgOrangeWallet;
